import { Component, OnInit, ViewChild } from '@angular/core';
import { IDocument } from 'src/app/models/IDocument';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { MatPaginator, MatDialog, MatTableDataSource } from '@angular/material';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DeleteDocumentComponent, ConfirmDialogModel } from '../delete-document/delete-document.component';
import { EditDocumentComponent } from '../edit-document/edit-document.component';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { AuditLog } from 'src/app/models/iauditlog.model';
@Component({
  selector: 'app-import-document',
  templateUrl: './import-document.component.html',
  styleUrls: ['./import-document.component.css']
})
export class ImportDocumentComponent implements OnInit {
  docmentInfo: IDocument;
  ImportDocForm: FormGroup;
  public docCatList: IDocument[] = [];
  //public multipleScans: IImageDocument[] = [];
  public childDocCategories: IDocument[] = [];
  public listProviders: IUserDetails[];
  public allDocList: IDocument[] = [];
  public editDocInfo: IDocument;
  public subCatList: IDocument[] = [];
  public subList: IDocument[] = [];
  documenttab = 1;
  public lstLocations: ILocationDetails[];

  //public faciliId: number = 1;
  public docCatId: number = 0;
  public catName: string = '';
  public PatId: number;
  public docuName: string = '';

  public dcoCount: number;
  public count: number;

  public filename: string;
  public docUrl: string;

  public myFiles: string[] = [];

  public result: IDocument;
  public frmData: any;
  public fileExt: any;

  selectedFood2: Number;
  selectedSubCat: number;

  selectedValue: string;
  disableTextbox = false;

  isImportTypeButton: boolean = true;

  providerControl = new FormControl('', [Validators.required]);
  public dataSource: any;
  //fileuploadDisable:boolean= true;
  result1: string = '';
  savedDocurl: any = '';
  message: string;
  locationid: number = 0;
  displayedColumns: string[] = ['Documnet Category', 'Doc.Description', 'Document Date', 'Document upload date', 'Uploaded By', 'Comments', 'Action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  hideDocumentsHeader: boolean = true;
  constructor(private fb: FormBuilder,
    private docService: DocumentService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private router: Router,
    private sharedService: SharedService,
    private toastr: ToastrService, public sanitizer: DomSanitizer) {
    this.savedDocurl = '';
    this.getSystem();
    //alert('Import Document page..')
    if (sessionStorage.getItem("hideDocumentsHeader") != null && sessionStorage.getItem("hideDocumentsHeader") != undefined) {
      this.hideDocumentsHeader = false;
    } else {
      this.hideDocumentsHeader = true;
    }
  }

  getSystem() {

    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("LocationId") != null || Number(sessionStorage.getItem("LocationId")) != 0) {
      this.locationid = parseInt(sessionStorage.getItem("LocationId"));
    }
  }
  formErrors = {
    'documentCategory': '',
    'docDescription': '',
    'documentName': '',
    'documentdate': '',
  };

  validationMessages = {
    'documentCategory': {
      'required': 'Please Select the Document Category',
    },
    'docDescription': {
      'required': 'Please Enter Document Description'
    },
    'documentName': {
      'required': 'Please Upload the Document'
    },
    'documentdate': {
      'required': 'Please Select the Current Date'
    },
  };

  ngOnInit() {
    this.getAllDocCategoryList();
    this.ImportDocForm = this.fb.group({
      documentId: [''],
      documentName: [''],
      documentdate: ['', Validators.required],
      subCategoryId: ['', Validators.required],
      subCategoryName: [''],
      docCategoryId: ['', Validators.required],
      patientId: [''],
      patientName: [''],
      docLocationId: [''],
      //facilityId: ['']
    });
    //this.formErrors;
    this.GetPatientDetails(); // pacha values
    this.GetIDocInfo(); // Object Creation
    this.getAllSubCategoryList();
    this.getLocations();

    this.ImportDocForm.markAllAsTouched();
    this.ImportDocForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.ImportDocForm);
    });
  }

  GetPatientDetails() {
    this.ImportDocForm.patchValue({
      patientId: CommonComponents.patientId,
      patientName: CommonComponents.patientName,
      //documentCategory: this.catName,
      documentdate: new Date(),
      //facilityId: Number(sessionStorage.getItem("FacilityId")),
      //docCategoryId: this.docCatId,
    });
  }

  getLocations() {
    ;
    this.sharedService.getLocationsByUser().subscribe(data => {
      this.lstLocations = data;
      sessionStorage.setItem('UserLocations', JSON.stringify(this.lstLocations));
      this.getLocationsByloginUser();
    });
  }
  doclocation: any;
  getLocationsByloginUser() {
    this.sharedService.getLocationsByLoginUser().subscribe(data => {
      this.doclocation = Number(data);
      if (this.doclocation == 0) {
        this.doclocation = this.lstLocations[0].locationId;
      }
      this.ImportDocForm.patchValue({
        docLocationId: this.doclocation,
      });
      sessionStorage.setItem("LocationId", this.ImportDocForm.value.docLocationId);
    });
  }

  GetIDocInfo() {
    this.docmentInfo = {
      documentId: null,
      documentName: '',
      documentdate: '',
      subCategoryId: null,
      subCategoryName: '',
      //categoryId: null,
      docCategoryId: null,
      documentCategory: '',
      patientId: null,
      patFullName: '',
      patDOB: null,
      patGender: '',
      patAge: null,
      extension: '',
      encounterId: '',
      facilityId: null,
      createdBy: '',
      locationId: null,
      fluoroscopeId: null,
      count: null,
      reportDocumentId: null
    }
  }

  onDocSubmit(docmentInfo): void {

    if (docmentInfo.documentId) {
      this.docService.updateDocument(docmentInfo).subscribe((results: any) => {
        this.result = results;
        this.toastr.success('This document was successfully uploaded'); //updated
        this.router.navigateByUrl('/Document');
      }

      );
    } else {

      this.frmData = new FormData();
      let docDate = this.datePipe.transform(docmentInfo.documentdate, "MM/dd/yyyy");
      let subCat = docmentInfo.subCategoryName;
      let docName = subCat + "_" + docDate;
      for (var i = 0; i < this.myFiles.length; i++) {
        this.frmData.append('fileUpload', this.myFiles[i]);
      }
      this.frmData.append('FacilityId', Number(sessionStorage.getItem("FacilityId")));  // LocationId
      this.frmData.append('PatId', docmentInfo.patientId.toString());
      this.frmData.append('DocCatId', docmentInfo.docCategoryId.toString());
      this.frmData.append('SubCatId', docmentInfo.subCategoryId.toString());
      this.frmData.append('subCatName', docName);
      this.frmData.append('DocName', docmentInfo.documentName);
      this.frmData.append('DocDate', this.datePipe.transform(docmentInfo.documentdate, "yyyy-MM-dd"));
      this.frmData.append('DocId', docmentInfo.documentId);
      this.frmData.append('FileExt', this.filename.split('.').pop());
      this.frmData.append('Createdby', encodeURIComponent(sessionStorage.getItem("userId")).toString());
      this.frmData.append('DocCat', docmentInfo.documentCategory);
      //this.frmData.append('LocationId', this.locationid);  // LocationId
      this.frmData.append('LocationId', this.doclocation);  // LocationId
      this.frmData.append('DocumentType', 'Upload');
      this.docService.insertDocument(this.frmData).subscribe(
        results => {
          this.result = results;
          this.docuName = this.result.documentName;
          this.toastr.success('This document was successfully uploaded');
          this.ClearDocValues();
          this.isImportTypeButton = true;
          //setTimeout(() => {
          const url = this.result.sasUri;
          this.savedDocurl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          //}, 10000);

        }
      );
    }
  }

  mapFormValuesToDocumetModel() {
    this.docmentInfo.documentId = this.ImportDocForm.value.documentId;
    this.docmentInfo.facilityId = Number(sessionStorage.getItem("FacilityId"));//this.ImportDocForm.value.facilityId;
    this.docmentInfo.patientId = this.ImportDocForm.value.patientId;
    this.docmentInfo.docCategoryId = this.ImportDocForm.value.docCategoryId;
    this.docmentInfo.subCategoryId = this.ImportDocForm.value.subCategoryId.subCategoryId;
    this.docmentInfo.subCategoryName = this.ImportDocForm.value.subCategoryId.subCategoryName
    this.docmentInfo.patFullName = this.ImportDocForm.value.patientName;
    this.docmentInfo.documentCategory = this.ImportDocForm.value.documentCategory;
    this.docmentInfo.documentName = this.ImportDocForm.value.documentName;
    this.docmentInfo.documentdate = this.ImportDocForm.value.documentdate;
    //this.docmentInfo.locationId = Number(sessionStorage.getItem("LocationId"))
    this.docmentInfo.locationId = this.doclocation;
  }

  getAllDocCategoryList() {
    if (sessionStorage.getItem('patientId') !== '' && sessionStorage.getItem('patientId') !== undefined) {
      this.docService.getAllDocCategory(Number(sessionStorage.getItem('patientId')), Number(sessionStorage.getItem("FacilityId")), 4).subscribe(data => {
        this.docCatList = data;
      });
    } else {
      this.toastr.warning("Please select Patient Id");
    }
  }

  // PreviewFile(e, item) {
  //   let pathurl: string = `file:///D:/GitDownloadProjects/md4-core-webapi/Md4coreService/Md4coreService/PatSummary/` + item.facilityId + `/` + item.patientId + `/` + item.docCategoryId + `/` + item.documentId + `.` + item.extension;
  //   return window.open(pathurl, null);
  //   // this.docService.getDocumentUrl(item.facilityId, item.patientId, item.docCategoryId, item.documentId, item.extension).subscribe(data => {
  //   //   this.docUrl = data;
  //   //   return window.open(`http://localhost:4200/${this.docUrl}`);
  //   // });
  // }

  getFileDetails(e) {
    this.myFiles = [];
    for (var i = 0; i < e.target.files.length; i++) {
      this.filename = e.target.files[i].name;
      this.myFiles.push(e.target.files[i]);
    }
    if (this.ImportDocForm.value.docCategoryId === "" || this.ImportDocForm.value.subCategoryId.subCategoryId === "" || this.ImportDocForm.value.docCategoryId === undefined || this.ImportDocForm.value.subCategoryId.subCategoryId === undefined) {
      this.message = "Enter Category & SubCategory"
    } else {
      this.message = "";
      this.mapFormValuesToDocumetModel();
      this.getDocumetCount(this.docmentInfo.patientId, this.docmentInfo.docCategoryId, this.docmentInfo.subCategoryId, this.datePipe.transform(this.docmentInfo.documentdate, "yyyy-MM-dd"), this.docmentInfo.locationId);
    }
  }

  toggleDisable() {
    this.disableTextbox = !this.disableTextbox;
  }

  ClearDocValues() {
    this.savedDocurl = '';
    //this.savedDocurl=null;
    this.ImportDocForm.patchValue({ docCategoryId: '', docDescription: '', docComments: '', providerName: '', subCategoryId: '', documentName: '' });

    this.message = "";
  }

  getAllSubCategoryList() {
    this.docService.getAllSubCategory().subscribe(data => {
      this.subCatList = data;
      //this.AuditLogs("USP_GET_DOCUMENT_SUBCATEGORIES", CommonComponents.patientId);
    });
  }
  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }
  onCategoryChange() {
    //this.fileuploadDisable = true;
    if (this.selectedFood2 === undefined) {
      this.subCatList;
    } else {
      this.message = "";
      this.subList = this.subCatList.filter(x => x.docCategoryId === this.selectedFood2);
      this.ImportDocForm.controls["subCategoryId"].setValue('');
      this.ImportDocForm.controls["subCategoryId"].updateValueAndValidity();
      this.isImportTypeButton = true;
    }
  }

  onSubCategoryChange() {
    //this.fileuploadDisable = false;
    if (this.selectedSubCat !== undefined) {
      this.message = "";
      this.isImportTypeButton = false;
    }
  }

  async getDocumetCount(patId: number, catId: number, subCatId: number, docDate: string, docloc: number) {

    await this.docService.getDocumentsCount(patId, catId, subCatId, docDate, this.docmentInfo.documentName, docloc).subscribe(data => {
      this.dcoCount = data;
      if (this.dcoCount == 0) {
        this.onDocSubmit(this.docmentInfo);
      } else {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '300px',
          height: '150px',
          data: { headerText: 'You are trying to upload the same file once again. Please confirm if you wish to proceed.' }
        });
        dialogRef.afterClosed().subscribe(result1 => {
          if (result1 && result1 != undefined) {
            this.onDocSubmit(this.docmentInfo);
          } else {
            //this.ClearDocValues();
            this.savedDocurl = '';
            //this.savedDocurl=null;
            this.ImportDocForm.patchValue({ documentName: '' });

            this.message = "";
            this.result1 = result1;
          }
        });
      }
    });
  }

  logValidationErrors(group: FormGroup = this.ImportDocForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  onselectionLocationchange(event) {
    ;
    this.doclocation = event.target.value;
  }
}
